module.exports = __webpack_public_path__ + "static/media/Classifications.df5c47f5.svg";